import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/global.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/css/forum-send-btn-overrides.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enregistrement du service worker pour PWA (installation sur mobile)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/sw.js`).then(
      (registration) => {
        console.log('SW enregistré:', registration.scope);
      },
      (err) => {
        console.warn('Échec enregistrement SW:', err);
      }
    );
  });
}
